<template>
  <div style="background: none">
    <div class="cdkeyCont">
      <div class="content">
        <h5>兑换码</h5>
        <p>您的朋友{{name}}给您转发了一张兑换码<span class="cardNo">{{cardNo}}</span>，可用于易保全旗下一站式电子合同及知识产权保护服务，请在72小时内兑换领取。</p>
        <div class="qrcode">
          <img :src="globalConfig.domain.backstage+'/common/uiqr?userId='+userId" />
        </div>
        <p class="loginInput">长按注册/登录，输入兑换码领取</p>
        <div class="copy" v-clipboard:copy="cardNo" v-clipboard:success="onCopy" v-clipboard:error="onError">复制兑换码</div>
      </div>
      <div class="ebq">
        <img src="../../static/img/m/logo.png" alt="易保全">
        <p>易保全作为国内领先的“区块链+司法+应用”一站式服务平台，可为企业及机关提供电子合同、原创作品保护、互联网司法（在线公证、在线仲裁）三大服务。</p>
      </div>
    </div>
    <el-dialog :visible.sync="copyDialog" :title="hint" center top="60%" :class="hint==='复制成功'?'success':'error'"></el-dialog>
  </div>
</template>

<script>
    import http from '@/http'
    import wx from 'weixin-js-sdk'

    export default {
        name: "Transpond",
        data() {
            return {
                name: '',
                cardNo: '',
                userId: '',
                copyDialog: false,
                hint: '',
            }
        },
        created() {
            var _this = this
            _this.name = decodeURI(_this.$route.query.name)
            _this.cardNo = _this.$route.query.activityCard
            _this.userId = _this.$route.query.userId
            this.getJsaipTicket()
        },
        methods: {
            getJsaipTicket() {
                var _this = this;
                var formData = new FormData
                formData.url = window.location.href
                http.post(this.globalConfig.domain.backstage + '/activity/jsapiTicket', formData,(response) => {
                    if (response.data && response.data.success) {
                        var data = response.data.data
                        wx.config({
                            appId: data.appId,
                            timestamp: data.timestamp,
                            nonceStr: data.noncestr,
                            signature: data.signature,
                            jsApiList: ['onMenuShareAppMessage']
                        })
                        wx.ready(() => {
                            wx.onMenuShareAppMessage({
                                title: '兑换码',
                                link: formData.url,
                                complete: function() {
                                    _this.getFreeze()
                                }
                            })
                        })
                    } else {

                    }
                });
            },
            getFreeze() {
                var _this = this
                var formData = new FormData
                formData.activityCardId = _this.$route.query.activityCardId
                formData.forwardType = 1
                formData.forwardContactWay = '微信用户'
                http.post(_this.globalConfig.domain.backstage + "/activity/activityCardFreeze",formData ,(response) => {
                    if (response.data && response.data.success) {
                        alert('转发成功')
                    } else {
                        alert('转发失败')
                    }
                });
            },
            onCopy() {
                this.copyDialog = true
                this.hint = '复制成功'
                setTimeout(() => {this.copyDialog = false}, 1000)
            },
            onError() {
                this.copyDialog = true
                this.hint = '复制失败'
                setTimeout(() => {this.copyDialog = false}, 1000)
            },
        }
    }
</script>

<style scoped lang="scss">
  .cdkeyCont {
    width: 100%;
    height: calc(100vh - 2rem);
    background: url("../../static/img/m/cdkeyBg.png") no-repeat;
    background-size: 100% 100%;
    padding-top: 2rem;

    .content {
      width: 95%;
      height: 11.41rem;
      padding-top: 0.35rem;
      margin: 0 auto;
      background: url("../../static/img/m/cdkeyCont.png") no-repeat;
      background-size: 100% 100%;

      h5 {
        font-size: 0.45rem;
        color: #022F4A;
      }
      p {
        width: 84%;
        margin: 0.24rem auto 0.43rem;
        text-align: left;
        font-size: 0.32rem;
        color: #022F4A;
        line-height: 0.4rem;
      }
      .qrcode {
        width: 4.88rem;
        height: 4.88rem;
        background: #FFFFff;
        margin: 0.43rem auto 0.16rem;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 4rem;
          height: 4rem;
        }
      }
      .loginInput {
        font-size: 0.35rem;
        font-weight: bold;
        color: #022F4A;
        text-align: center;
      }
      .copy {
        width: 5.92rem;
        height: 1.12rem;
        background: url("../../static/img/m/copyCdkey.png") no-repeat;
        background-size: 100% 100%;
        margin: 1.55rem auto 0;
        font-size: 0.43rem;
        font-weight: bold;
        color: #022F4A;
        line-height: 1.12rem;
      }
    }
    .ebq {
      width: 91%;
      margin: 0.67rem auto 0;

      img {
        width: 2.16rem;
        height: 0.56rem;
      }
      p {
        font-size: 0.32rem;
        color: #FFFFff;
        line-height: 0.45rem;
        text-align: left;
        margin-top: 0.4rem;
      }
    }
  }
  .success {
    /deep/ .el-dialog__header {
      height: 1rem;
      line-height: 1.1rem;
      background: rgb(240,249,235);
    }
    /deep/ .el-dialog__title {
      font-size: 0.43rem;
      font-weight: bold;
      color: rgb(172,222,148);
    }
    /deep/ .el-dialog__body {
      padding: 0;
    }
  }
  .error {
    /deep/ .el-dialog__header {
      height: 1rem;
      line-height: 1.1rem;
      background: rgb(254,240,240);
    }
    /deep/ .el-dialog__title {
      font-size: 0.43rem;
      font-weight: bold;
      color: rgb(245,108,108);
    }
    /deep/ .el-dialog__body {
      padding: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Transpond.vue